import AccentTitle from '../UI/AccentTitle';

interface BaseProps {
  children?: React.ReactNode;
}
interface LayoutCardProps extends BaseProps {}

export const LayoutCardTitle = (props: { title: string; actions?: React.ReactNode }) => {
  const { title, actions } = props;
  return (
    <div className='border-b flex gap-2'>
      <div className='flex-grow'>
        <AccentTitle title={title} />
      </div>
      <div className='shrink-0 px-4 py-4'>{actions}</div>
    </div>
  );
};

export const LayoutCardContent = (props: BaseProps) => {
  const { children } = props;
  return <div className='py-5'>{children}</div>;
};

export const LayoutCard = (props: LayoutCardProps) => {
  const { children } = props;
  return <div className='bg-white rounded shadow-md'>{children}</div>;
};
